import axios from '../axios/axios-auth'

export default class OrganizationsService {

    /**
     * V3
     **/

    getAllV3(feature = null) {
        if (!feature) {
            return axios.get(`/api/v3/organizations`).then(response => response.data)
        }

        return axios.get(`/api/v3/organizations?feature=${feature}`).then(response => response.data)
    }

    getOrganizationAgroPreferences(orgId) {
        return axios.get(`/agro-service/v1/organizations/${orgId}/agro-preferences`)
    }

    getOrganizationFeatureFlags(orgId) {
        return axios.get(`/api/v3/organizations/${orgId}/featureFlags`).then(response => response.data)
    }

    updateOrganization(orgId, body) {
        return axios.patch(`/api/v3/organizations/${orgId}`, body).then(response => response.data)
    }

    createOrganizationAgroPreferences(orgId, body) {
        return axios.post(`/agro-service/v1/organizations/${orgId}/agro-preferences`, body).then(response => response.data)
    }

    updateOrganizationAgroPreferences(preferencesId, body) {
        return axios.patch(`/agro-service/v1/agro-preferences/${preferencesId}`, body).then(response => response.data)
    }
}
